import styled from 'styled-components';

const BackgroundBar = styled('div')`
  position: absolute;
  top: 8px;
  height: 8px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  left: 0;
  z-index: -15;
  width: 100%;
  background-color: ${(props) => props.theme.colors.grey2};
`;

export default BackgroundBar;
